<template>
    <div
        :ref="name"
        :id="name"
    >
        <component
            v-if="!isSpanishOverride && !showSlot"
            :is="component"
            :config="renderedContent"
        >
        </component>
        <slot
            v-if="showSlot"
            name="content0"
            :promo-link="promoLink"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import HeroBannerPreLoad from '../HeroBanner/preLoad.vue'
import OfferLayerPreLoad from '../OfferLayer/preLoad.vue'
export default {
    name: "ContentZone",
    components: {
        "heroBanner": HeroBannerPreLoad,
        "offerLayer": OfferLayerPreLoad,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        component: {
            type: String,
            required: true,
        },
        override: {
            type: String,
            required: true,
        },
        promoLink: {
            type: String,
            default: null,
        },
        productMetadata: {
            type: String,
            required: false,
            default: "[]",
        },
    },
    data: () => ({
        renderedContent: {}
    }),
    watch: {
        generatedContent(value) {
          this.updateRenderedContent(value)
        }
    },
    beforeMount() {
        if (this.campaignResponses.length > 0 && this.campaignResponses[0].payload?.contentZone === this.name) {
            let value = this.generate()

            this.updateRenderedContent(value)
        }

        this.updateContentZone([ this.name ])
    },
    computed: {
        ...mapState('Personalization',[
            'campaignResponses',
        ]),
        generatedContent() {
            return this.generate()
        },
        isSpanishOverride() {
            const host = window.location.hostname
            const href = window.location.href

            if (host === 'es.breezeline.com' || href === 'https://staging.breezeline.com/internet-test') {
                return (this.override === 'yes')
            }

            return false
        },
        showSlot() {
            return this.isSpanishOverride ? true : (Object.keys(this.renderedContent).length === 0 && this.override === 'no')
        }
    },
    methods: {
        ...mapActions('Personalization',[
            'updateContentZone',
        ]),
        updateRenderedContent(value) {
          if (value) {
            this.renderedContent = {...value, promoLink:this.promoLink, productMetadata: this.productMetadata}
            this.$nextTick(() => {
              this.$emit(
                  'updated-content',
                  {
                    element: this.$refs[this.name],
                    campaign: value
                  }
              )
            });
          }
        },
        generate() {
          let content = null
          let isDynamic = false

          if (this.campaignResponses.length) {
            content = this.campaignResponses.find(c => {

              // static template
              if (c.payload?.contentZone && c.payload?.contentZone === this.name) {
                return true
              }

              // dynamic template
              if (c.payload?.templateConfig?.contentZone && c.payload?.templateConfig?.contentZone === this.name) {
                isDynamic = true
                return true
              }

              return false
            })
          }

          if (isDynamic) {
            const regex = /%%[a-zA-Z]+%%/;

            Object.keys(content.payload.templateConfig).forEach((key) => {
              let value = (content.payload.templateConfig[key])?.toString()

              if (value && value.length > 0 && regex.test(value)) {
                regex.exec(value).forEach(match => {
                  const matchValue = content.payload[match.replaceAll('%', '')]

                  // directly replace in the templateConfig
                  content.payload.templateConfig[key] = value.replaceAll(match, matchValue)
                  value = content.payload.templateConfig[key]
                })
              }
            })
          }

          return content || {}
        }
    },
}
</script>

<style scoped>

</style>
